@if (showStatusBanner() && selectedChannel() && selectedChannel()?.status) {
<div class="channel-status" [ngClass]="'channel-status__' + $safeNavigationMigration(selectedChannel()?.status)">
  <div class="channel-status__content">
    <mat-icon svgIcon="info"></mat-icon>
    {{ 'NGX-MESSAGING.STATUS.' + $safeNavigationMigration(selectedChannel()?.status) | translate }}
  </div>
  <mat-icon svgIcon="close_circle" class="channel-status__close-icon" (click)="closeBanner()"></mat-icon>
</div>
}
